import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { API_BASE } from "../api";
import BaseLayout from "./BaseLayout";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState({ type: "", content: "" });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setMessage({ type: "error", content: "Invalid reset link. Please request a new one." });
    }
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage({ type: "", content: "" });

    if (password.length < 8) {
      setMessage({ type: "error", content: "Password must be at least 8 characters long." });
      return;
    }
    if (password !== confirmPassword) {
      setMessage({ type: "error", content: "Passwords do not match." });
      return;
    }

    setSubmitting(true);

    try {
      const response = await axios.post(`${API_BASE}/mail/reset-password`, { token, password });
      setMessage({ type: "success", content: response.data.message || "Password reset successfully! Redirecting to login..." });
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (error) {
      if (error.response) {
        const errMsg = error.response.data.error || error.response.data.message || "";
        if (errMsg.toLowerCase().includes("expired")) {
          setMessage({ type: "error", content: "This reset link has expired. Please request a new one." });
        } else if (errMsg.toLowerCase().includes("invalid")) {
          setMessage({ type: "error", content: "Invalid or tampered reset link. Please request a new one." });
        } else {
          setMessage({ type: "error", content: errMsg || "An error occurred. Please try again." });
        }
      } else {
        setMessage({ type: "error", content: "An error occurred. Please try again." });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <BaseLayout>
      <div className="auth-wrapper">
        <img src="/loginlogo.png" className="auth-logo" alt="FlamePicks" />
        <div className="auth-card">
          {message.content && (
            <div
              className={`alert ${message.type === "error" ? "alert-danger" : "alert-success"}`}
              role="alert"
            >
              {message.content}
            </div>
          )}
          {!success && token && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="password">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="auth-submit-btn" disabled={submitting}>
                {submitting ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          )}
          <div className="auth-footer-link">
            <Link to="/forgot-password">Request a new reset link</Link>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default ResetPasswordPage;
